<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="PCATable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :table_height_adjust="-8" :isBusy="isBusy_table1" @on_query="on_query"
        @state_change="state_change" :show_toolbar_button="[0, 0, 0, 0, 1]" @on_cell_button_click="on_cell_button_click"
        tableref="281372ccaf824540b3d8049dfccce882">
        <template #query>
          {{ $t("common.provider") + $t("common.num") }}：<el-input size="small" style="width: 150px"
            v-model="SEI_Name"></el-input>
        </template>
        <template #toolbar="">
          <el-button type="info" plain @click="createForm('new')" style="width: 55px" class="ml-2 iconfont icon-add-new"
            size="mini"></el-button>
        </template>
      </TableMain>
    </BaseContainer>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm"
          style="height: 180px">
          <el-col :span="12">
            <el-form-item :label="$t('common.provider')" prop="AccountNum">
              <el-select size="small" v-model="dataForm.AccountNum" filterable clearable
                :placeholder="$t('common.provider')" class="w-100" :loading="select_loading"
                @focus="getBaseDataVend(dataForm.AccountNum)" @change="vendChanged" :filter-method="filterMethod">
                <el-option v-for="item in vend_options" :key="item.AccountNum"
                  :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('common.capacity')" prop="ProductionCapacity">
              <el-input size="small" style="width: 100%" @input="
                dataForm.ProductionCapacity = dataForm.ProductionCapacity.replace(
                  /[^0-9.]/g,
                  ''
                )
                " v-model="dataForm.ProductionCapacity" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('common.date')" prop="set_date">
              <el-date-picker size="small" type="date" :placeholder="$t('common.date')" v-model="dataForm.set_date"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$t('common.description')" prop="description">
              <el-input type="textarea" v-model="dataForm.description" rows="5"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import * as ProductionCapacityController from "../../controllers/fi/ProductionCapacityController"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "ProductionCapacityAdd",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: this.$t('common.date'),
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_production_capacity",
      },
      modal_title: "create_capacity",
      fields: _.cloneDeep(ProductionCapacityController.fields.default),
      dataForm: _.cloneDeep(ProductionCapacityController.dataForm),
      rules: _.cloneDeep(ProductionCapacityController.rules),
      isBusy_table1: false,
      select_loading: false,
      vend_options: [],
      SEI_Name: "",
    }
  },
  created() { },
  methods: {
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy_table1 = true
      this.dataForm = _.cloneDeep(ProductionCapacityController.dataForm)

      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = {
        is_deleted: 0,
        SEI_Name: { like: "%" + this.SEI_Name + "%" },
      }
      if (!_.isNull(date_range) && this.SEI_Name == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["set_date"] = { ">=": _fromDate, "<=": _toDate }
      }
      let _result = await ProductionCapacityController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["set_date", "id"], ["desc", "desc"]))
      }
      this.isBusy_table1 = false
    },
    ///初始化 vend
    getBaseDataVend(v) {
      this.vend_options = _.cloneDeep(
        _.orderBy(
          this.$store.state.biz_data.baseData.Vender,
          ["modifiedDateTime"],
          ["desc"]
        )
      ).splice(0, 300)
    },

    ///筛选cust
    filterMethod(v) {
      if (v) {
        let _filter_list = _.filter(
          _.cloneDeep(
            _.orderBy(
              this.$store.state.biz_data.baseData.Vender,
              ["modifiedDateTime"],
              ["desc"]
            )
          ),
          function (t) {
            return t.AccountNum.indexOf(v) > -1 || t.SEI_Name.indexOf(v) > -1
          }
        )
        this.vend_options = _filter_list.splice(0, 300)
      } else {
        this.vend_options = _.cloneDeep(
          _.orderBy(
            this.$store.state.biz_data.baseData.Vender,
            ["modifiedDateTime"],
            ["desc"]
          )
        ).splice(0, 300)
      }
    },
    vendChanged() {
      if (this.dataForm.AccountNum != "") {
        let _m = _.find(this.$store.state.biz_data.baseData.Vender, {
          AccountNum: this.dataForm.AccountNum,
        })
        if (_m) {
          this.dataForm.SEI_Name = _m.SEI_Name
        }
      }
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          this.dataForm = _.cloneDeep(ProductionCapacityController.dataForm)
          this.dataForm.set_date = this.$date.format(new Date(), "yyyy-MM-dd")
          title = "create_capacity"
          break
        case "edit":
          title = "edite_capacity"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },
    ///新增修改
    saveData(cb) {
      let _this = this
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          _data.ProductionCapacity = parseFloat(_data.ProductionCapacity)
          _data.set_date = this.$date.format(
            new Date(_data.set_date),
            "yyyy-MM-dd"
          )
          let _list = []
          _list.push(_data)
          ///保存数据

          let _rel_save_data = await ProductionCapacityController.methods.saveData(
            _list
          )
          // console.log(_rel_save_data);
          if (!_.isNull(_rel_save_data)) {
            if (_.isInteger(_data.id)) {
              _data.set_date = _this.$date.format(
                new Date(_data.set_date),
                "yyyy-MM-dd"
              )
              _this.$refs.PCATable1.UpdateItems({ id: _data.id }, _data)
            } else {
              if (parseFloat(_data.ProductionCapacity) > 1) {
                this.msgToasts(this.$t("notify.capacity_must_0_1"), "info")
                cb(null)
                return
              }
              ///新增时判断是否检查通过
              let _check_list = []
              let filter_check_list = _.filter(_rel_save_data, {
                Code: "data/e/check_existe_production_capacity",
              })
              _.each(filter_check_list, (t) => {
                if (
                  !_.isNull(t.Result) &&
                  t.Result.Data &&
                  !_.isNull(t.Result.Data[0]) &&
                  t.Result.Data[0][0].is_check_ok == 1
                ) {
                  _check_list.push(_data.AccountNum)
                }
              })
              if (_check_list.length > 0) {
                cb(false)
                _this.msgToasts(this.$t("notify.action_unsuccessfully") + "，" + this.$t("common.provider") + _.join(_check_list, "，") + "，" + this.$t("common.capacity") + this.$t("common.is_existed") + "！", "error")
                return
              }

              let add_list = []
              let filter_add_list = _.filter(_rel_save_data, {
                Code: "data/i/sPlant_ProductionCapacity",
              })
              _.each(filter_add_list, (t) => {
                if (
                  t.Result.Data &&
                  !_.isNull(t.Result.Data) &&
                  !_.isNull(t.Result.Data[0])
                ) {
                  t.Result.Data[0][0].create_by_username = this.$global.global_data.local_username
                  add_list.push(t.Result.Data[0][0])
                }
              })
              if (add_list.length > 0) {
                _this.$refs.PCATable1.InsertItems(add_list)
              }
            }
            ///成功
            cb(true, true)
            let remove_data = _.filter(this.$refs.PCATable1.my_data, (t) => {
              if (
                t.AccountNum == _this.dataForm.AccountNum &&
                t.set_date.replace("T00:00:00", "") ==
                this.$date.format(this.dataForm.set_date, "yyyy-MM-dd")
              ) {
                return t
              }
            })
            console.log(remove_data)
            this.$refs.PCATable1.RemoveItems(remove_data)
            _this.msgToasts(this.$t("notify.action_successfully"), "success")
          } else {
            ///失败
            cb(true, false)
            _this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
          }
        } else {
          cb(false)
          _this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        }
      })
    },
    //#endregion

    //#region 状态切换
    state_change(data, cb) {
      if (data.state === "deleted") {
        this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
          if (v) {
            let result = await ProductionCapacityController.methods.deleteData(
              data.selected_items
            )
            if (!_.isNull(result)) {
              let _msg = this.$t("notify.action_successfully")

              this.msgToasts(_msg, "success")
              cb(true, [])
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
        })
      }
      // else if (data.state === "approved" || data.state === "unapproved") {
      //   let _msg = data.state == "approved" ? "审批" : "反审";
      //   this.msgModal(this.$t("notify.is_continue")).then(async v => {
      //     if (v) {
      //       let _list = _.cloneDeep(data.selected_items);
      //       _.each(_list, t => {
      //         t.is_approved = data.state == "approved" ? true : false;
      //       });
      //       // console.log(_list);
      //       let result = await ProductionCapacityController.methods.approveData(_list);
      //       if (result) {
      //         this.msgToasts(this.$t("notify.action_successfully"), "success");
      //         cb(true);
      //       } else {
      //         this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
      //         cb(false);
      //       }
      //     }
      //   });
      // }
    },
    on_cell_button_click(data) {
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.dataForm.set_date = new Date(
        this.$date.format(
          new Date(this.dataForm.set_date),
          "yyyy-MM-dd HH:mm:ss"
        )
      )
      this.createForm("edit")
    },
    //#endregion


    // 限制只能输入数字(可以输入两位小数)
    limitInputPointNumber(key) {
      let val = this.dataForm[key]

      if (val === 0 || val === "0" || val === "") {
        this.dataForm[key] = ""
      } else {
        let value = null
        value = String(val).replace(/[^0-9.]/g, "") // 清除“数字”和“.”以外的字符
        // ^ [\+\-] ?\d *?\.?\d*?$
        // value = value.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
        // value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        // value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
        console.log(value)
        this.dataForm[key] = value
      }
    },
  },
}
</script>
